export default function getData () {
  return {
    title: {
      text: '단위(원)',
      textStyle: {
        color: '#808080',
        fontWeight: 50,
        fontSize: 15
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      // data: ['Forest', 'Steppe', 'Desert']
      right: 0,
      itemWidth: 12,
      itemHeight: 12,
      textStyle: {
        color: '#808080',
        fontWeight: 500
      }
    },
    grid: {
      left: '2%',
      right: '2%',
      bottom: '3%',
      top: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [], // 임의의 월별 데이터
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: '토스 매출',
        type: 'bar',
        stack: '총 매출',
        itemStyle: {
          color: '#999999',
        },
        data: []
      },
      {
        name: '계좌이체 매출',
        type: 'bar',
        stack: '총 매출',
        itemStyle: {
          color: '#998888',
        },
        data: []
      },
      {
        name: '환불',
        type: 'bar',
        stack: '총 지출',
        itemStyle: {
          color: '#99DD77',
        },
        data: []
      },
      {
        name: '유지비',
        type: 'bar',
        stack: '총 지출',
        barWidth: 15,
        itemStyle: {
          color: '#97DD66',
        },
        data: []
      },
      {
        name: '수수료',
        type: 'bar',
        stack: '총 지출',
        barWidth: 15,
        itemStyle: {
          color: '#87DD66',
        },
        data: []
      },
      {
        name: '판매이익',
        type: 'bar',
        barWidth: 15,
        stack: '',
        itemStyle: {
          color: '#FF0000'
        },
        emphasis: {
          focus: 'series'
        },
        data: []
      },
    ]
  }
}
